(function($){
  $(document).ready(function(){

    $('.product-filter').not('.product-filter--initilized').each(function(){
      const qs = new QuickSearch($(this));
    });

  });
})(jQuery);

class QuickSearch{
  constructor($w) {
    const _this = this;

    this.$w = $w;

    this.is_loading = false;
    this.collectionId = this.$w.data('collection-id');
    this.q = '';
    this.ajax = null;

    this.$w.on('ajax-filter-loaded', function(){
      _this.q = -1;
      _this.update();
    });

    this.$w.addClass('product-filter--initilized');

    this.update();
  }

  update(){
    const $input = this.$w.find('input[name="cq"]');
    this.search($input.val());
  }

  search(q) {
    const _this = this;

    if (  this.q === q ) {
      return;
    }
    this.q = q;
    console.log('QS: ' + this.q);
    if ( !q ) {
      return;
    }

    let sort = this.$w.find('select[name="sort_by"]').val();

    let path = boostWidgetIntegration.config.searchUrl;
    let data = {
      t: Date.now(),
      shop: boostWidgetIntegration.config.shop.domain,
      page: 1,
      limit: 48,
      sort: (sort === 'manual' ? 'relevance' : sort),
      build_filter_tree: true,
      templateId: boostWidgetIntegration.config.templateId,
      pf_c_collection: this.collectionId,
      filter: true,
      q: this.q,
    }

    let priceLow = 0;
    let priceHigh = 0;
    if ( this.$w.find('input[name="filter.v.price.gte"]').length ) {
      priceLow = this.$w.find('input[name="filter.v.price.gte"]').val();
    }
    if ( this.$w.find('input[name="filter.v.price.lte"]').length ) {
      priceHigh = this.$w.find('input[name="filter.v.price.lte"]').val();
    }
    if ( priceLow || priceHigh ) {
      data['pf_p_price[0]'] = priceLow+':'+priceHigh;
    }

    const params = new URLSearchParams(data);
    const url = path + '?' + params.toString();

    // console.log(url);

    if ( this.ajax) {
      this.ajax.abort();
    }

    this.$w.addClass('ajax-filter--loading').addClass('ajax-filter--loading2');
    this.$w.append(wait());

    this.ajax = $.ajax({
      url: url,
      method: 'GET',
      cache: true,
      dataType: 'json',
      success: function ( resp, status ) {
        console.log(resp);
        const handles = [];
        for ( const i in resp.products) {
          const product = resp.products[i];
          handles.push( product.handle );
        }
        const url = '/pages/quick-search-results/'+handles.join(',');

        this.ajax = this.ajax = $.ajax({
          url: url,
          method: 'GET',
          cache: true,
          dataType: 'html',
          success: function (resp2, status) {

            const $list = $(resp2).find('#list');
            _this.$w.find('.product-teasers2').html($list.html());

            console.log(resp.total_product, resp.products.length);
            if ( resp.total_product > resp.products.length ) {
              _this.$w.find('.product-teasers2').append('<div class="editor tac">Not all quick search results shown. Try to refine your quick search</div>');
            }

            _this.$w.find('.pagination__more').hide();

            _this.$w.find('.pagination__intro').html('('+handles.length + ' results)');

            _this.$w.removeClass('ajax-filter--loading').removeClass('ajax-filter--loading2');
            remove_wait(_this.$w);

          },
          error: function (xhr, status, error) {
            console.log('quick search error', status, error);
            if (status === 'abort') {
              // do nothing
            } else {
              var resp = xhr.responseText;
              // If we have ajaxify wrap inside
              alert('AJAX error! ' + status + ', ' + error);
              _this.$w.removeClass('ajax-filter--loading').removeClass('ajax-filter--loading2');
              remove_wait(_this.$w);
              _this.is_loading = false;
            }
          }
        });
      },
      error: function ( xhr, status, error ) {
        console.log ( 'quick search error', status, error );
        if ( status === 'abort' ) {
          // do nothing
        } else {
          var resp = xhr.responseText;
          // If we have ajaxify wrap inside
          alert('AJAX error! ' + status + ', ' + error);
          _this.$wrap.removeClass('ajax-filter--loading').removeClass('ajax-filter--loading2');
          remove_wait(_this.$wrap);
          _this.is_loading = false;
        }
      }
    });
  }
}
